import React from 'react';
import { Download } from 'lucide-react';
import { QUALIOPI_LOGO } from '../data/constants';
const QUALIOPI_CERTIFICATES = [{
  label: 'Actions de formation',
  url: '/documents/Certificat_Qualiopi_Actions_de_formation.pdf'
}, {
  label: 'Actions de formation par apprentissage',
  url: '/documents/Certificat_Qualiopi_Formation_par_apprentissage.pdf'
}];
export function QualiopiTeaser() {
  return <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-100" data-id="element-625" data-mp="1s86vr9e2acey">
      <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-626" data-mp="1n7rggca7yuuc">
        <div className="flex-shrink-0 bg-white p-4 rounded-2xl shadow-sm border" data-id="element-627" data-mp="1j65ve3nj7a92">
          <img src={QUALIOPI_LOGO} alt="Logo officiel Qualiopi — processus certifié, République Française" className="w-[320px] max-w-full h-auto object-contain" data-id="element-628" data-mp="1j8a7v9zhxhky" />
        </div>
        <div className="flex-1 text-center md:text-left" data-id="element-629" data-mp="38ku9qafon29q">
          <h2 className="font-heading text-2xl md:text-3xl font-bold mb-4" data-id="element-630" data-mp="38jar4d6k0f4s">
            Certification Qualiopi
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mb-6" data-id="element-631" data-mp="1c8r15asvliqu">
            Zillenium Alternance est certifié Qualiopi pour ses actions de
            formation et de formation par apprentissage. Nous nous engageons
            dans une démarche d'amélioration continue pour garantir la qualité
            de nos enseignements.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl" data-id="element-632" data-mp="1qy6t2u457u84">
            {QUALIOPI_CERTIFICATES.map((cert, i) => <a key={cert.url} href={cert.url} download className={`group flex items-center gap-4 p-4 rounded-2xl border transition-all hover:-translate-y-0.5 hover:shadow-md focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none ${i === 0 ? 'bg-primary text-white border-primary hover:bg-primary-dark focus-visible:ring-primary' : 'bg-white text-primary-dark border-brand-orange/40 hover:border-brand-orange focus-visible:ring-brand-orange'}`} data-id="element-633" data-mp="1v1cvfqo4x19b" data-mpi={i}>
                <span className={`shrink-0 w-11 h-11 rounded-xl flex items-center justify-center transition-transform group-hover:scale-110 ${i === 0 ? 'bg-white/15' : 'bg-brand-orange/10'}`} data-id="element-634" data-mp="2jjvevwyfqa7i">
                  <Download className={`w-5 h-5 ${i === 0 ? 'text-white' : 'text-brand-orange'}`} data-id="element-635" data-mp="29lfndsvhwyxh" />
                </span>
                <span className="flex flex-col text-left min-w-0" data-id="element-636" data-mp="20t3yibg15jjm">
                  <span className={`text-[11px] font-medium uppercase tracking-wide ${i === 0 ? 'text-lavande' : 'text-muted-foreground'}`} data-id="element-637" data-mp="20rsty9erg7rg">
                    Télécharger le certificat
                  </span>
                  <span className="font-bold leading-tight break-words" data-id="element-638" data-mp="1lvbili6kmt4w">
                    {cert.label}
                  </span>
                </span>
              </a>)}
          </div>
        </div>
      </div>
    </div>;
}